export default __webpack_public_path__ + "media/images/gallery/party-flyer-78cab518f946ff82aa8c8398ccd9e731.jpg";